import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const Header = () => {
  const { language, fontFamilyStyle, lang, switchLanguage } = useLanguage();

  const handleLanguageChange = (event) => {
    const selectedLang = event.target.value;
    switchLanguage(selectedLang);
  };

  const prefix = `/${lang}`;

  React.useEffect(() => {
    const modalElement = document.getElementById("video_modal");
    if (!modalElement) return;
    const embedUrl =
      "https://www.youtube.com/embed/jNOn95tn6j8?autoplay=1&rel=0&playsinline=1";
    const play = () => {
      const frame = modalElement.querySelector("iframe");
      if (frame) frame.src = embedUrl;
    };
    const stop = () => {
      const frame = modalElement.querySelector("iframe");
      if (frame) frame.src = "about:blank";
    };
    modalElement.addEventListener("shown.bs.modal", play);
    modalElement.addEventListener("hidden.bs.modal", stop);
    return () => {
      modalElement.removeEventListener("shown.bs.modal", play);
      modalElement.removeEventListener("hidden.bs.modal", stop);
    };
  }, []);

  return (
    <header className="page-header px-md-4 py-md-3 py-2">
      <div className="container-fluid">
        <nav className="navbar navbar-expand-md" style={{ fontFamily: fontFamilyStyle }}>
          {/* Mobile Navigation */}
          <div className="mobile_nav d-md-none">
            <button
              className="btn toogle_btn d-md-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasExample"
              aria-controls="offcanvasExample"
            >
              <span>
                <img src="/assets/imges/menu.svg" alt="menuicon" />
              </span>
            </button>
          </div>

          {/* Offcanvas Menu */}
          <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
            <div className="offcanvas-header">
              <h5 className="offcanvas-title yellow" id="offcanvasExampleLabel">
                <Link to={prefix}>
                  <img src="/assets/imges/logo.svg" alt="logo" width={62} />
                </Link>
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>

            {/* Language-specific menu */}
            {language === "English" ? (
              <div className="offcanvas-body">
                <nav className="navbar menubar">
                  <ul className="navbar-nav">
                    <li className="nav-item"><a className="nav-link active" href={`${prefix}#home`}>Home</a></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#Features`}>Features</a></li>
                    <li className="nav-item"><a className="nav-link" href="/#Schools">School</a></li>
                    <li className="nav-item"><Link className="nav-link" to={`${prefix}/blog`}>Blog</Link></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#articles`}>Articles</a></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#`}>Download</a></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#Contcat-us`}>Contact us</a></li>
                    <li className="nav-item"><a className="nav-link" href="https://www.youtube.com/@khatt.app1" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a></li>
                  </ul>
                </nav>
              </div>
            ) : (
              <div className="offcanvas-body">
                <nav className="navbar menubar">
                  <ul className="navbar-nav">
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#Features`}>الميزات</a></li>
                    <li className="nav-item"><a className="nav-link" href="/#Schools">المدارس</a></li>
                    <li className="nav-item"><Link className="nav-link" to={`${prefix}/blog`}>مدونة</Link></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#articles`}>مقالات</a></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#`}>تحميل</a></li>
                    <li className="nav-item"><a className="nav-link" href={`${prefix}#Contcat-us`}>اتصل بنا</a></li>
                    <li className="nav-item"><a className="nav-link active" href={`${prefix}#home`}>الواجهة</a></li>
                    <li className="nav-item"><a className="nav-link" href="https://www.youtube.com/@khatt.app1" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a></li>
                  </ul>
                </nav>
              </div>
            )}
          </div>

          {/* Language Select */}
          <div className="ms-auto me-2">
            <select
              className="form-select"
              value={lang}
              onChange={handleLanguageChange}
              aria-label="Language select"
            >
              <option value="ar">عربي - E</option>
              <option value="en">English - ع</option>
            </select>
          </div>

          <Link className="navbar-brand" to={prefix}>
            <img src="/assets/imges/logo.svg" alt="logo" className="img-fluid" />
          </Link>
        </nav>
      </div>

      {/* Video Modal */}
      <div
        className="modal fade"
        id="video_modal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="text-end p-2">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div style={{ display: "flex", justifyContent: "center", backgroundColor: "black", padding: "10px" }}>
              <div style={{ width: "100%", maxWidth: "340px", aspectRatio: "9 / 16" }}>
                <iframe
                  title="Khat demo video"
                  src="https://www.youtube.com/embed/jNOn95tn6j8?rel=0&playsinline=1"
                  style={{ width: "100%", height: "100%", border: 0 }}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
